import { useSettings } from "@/store";
import axios, { AxiosResponse } from "axios";


export function configureAxios() {

  const settings = useSettings();
  axios.interceptors.request.use((request) => {
    if (settings.apiToken) request.headers.Authorization = `Bearer ${settings.apiToken}`;
    return request;
  });


  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async (error) => {
      if (error.response && error.response.status === 401 && !error.config.retry) {
        error.config.retry = true;
        await settings.reloadApiKey();
        return axios(error.config);
      }

      return Promise.reject(error);
    }
  );
}